module.exports = __webpack_public_path__ + "img/2X.1.7c357c11.jpg";